// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class QSTICK extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'QStick';
        this.Comments =
            'Moving average that shows the difference between the prices at which an issue opens and closes';
        this.SetIndicatorLine('QSTICK', Color.Blue, 1, LineStyle.SimpleChart);
        this.SetLevelLine('Zero', 0, Color.Gray, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.MAType = MAMode.SMA;
        super.InputParameter(new InputParameterCombobox('MAType', 'Type of moving average', 1, [
            { Simple: MAMode.SMA },
            { Exponential: MAMode.EMA },
            { Modified: MAMode.SMMA },
            { 'Linear Weighted': MAMode.LWMA }
        ]));
        this.MAPeriod = 20;
        super.InputParameter(new InputParameterInteger('MAPeriod', 'Period of MA', 2, 1, 9999));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    createInternalIndicators() {
        const accessor = (offset) => {
            return (this.CurrentData.getPriceByType(PriceType.Close, offset) -
                this.CurrentData.getPriceByType(PriceType.Open, offset));
        };
        if (this.MAType === MAMode.SMA || this.MAType === MAMode.LWMA) {
            this.maIndicator = this.Indicators.iMAOnArray(this.CurrentData, accessor, this.MAPeriod, this.MAType);
        }
        else {
            this.maIndicator = this.Indicators.iMAExOnArray(this.CurrentData, accessor, this.MAPeriod, this.MAType, 0, 0);
        }
        return [this.maIndicator];
    }
    GetIndicatorShortName() {
        return 'QSTICK(' + this.MAPeriod + ')';
    }
    NextBar() {
        super.NextBar();
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count <= this.MAPeriod) {
            return;
        }
        const maValue = this.maIndicator.GetValue();
        this.SetValue(0, 0, maValue);
    }
}
